import React, { useRef } from 'react';
import emailjs from '@emailjs/browser';
import './Form.css';
 const ContactForm = () => {
  const form = useRef();

const showMessage =()=>{
  var dialog = document.createElement("dialog");
  dialog.innerHTML = "This is a message box.";
  dialog.show();
}

  const sendEmail = (e) => {
    e.preventDefault();
    const firstName = document.getElementById("name").value;
    emailjs.sendForm("service_l2gi2xc","template_nhnb0d6", form.current,"NEnHECycrzNoki7LY")
      .then((result) => {
          console.log(result.text);
          alert("Hello, "+firstName+" your contact information has been sent. Expect me to reach out to you within the next 3 business days.");
          e.target.reset();
         
        
      }, (error) => {
          console.log(error.text);
      });
  };
////  this needs to be fixed !!! No clearing of form inputs and no action on submit 
  return (
    <div className="contact-form-container"> {/* inside this edit the css size when using phone */}
    <p> Please fill out fields located below  </p>
    
  <div className="form-wrapper">
  <form ref={form} onSubmit={sendEmail}>
    <div className="form-group">
      <label htmlFor="name">Name*:</label>
      <input
        type="text"
        name="name"
        id="name"
        required
      />
    </div>
    <div className="form-group">
      <label htmlFor="email">Email*:</label>
      <input
        type="email"
        name="email"
        required         
      />
    </div>
    
   
    <div className="form-group">
        <label htmlFor="ExtraInfo">Let me know what you would like to talk about*:</label>
        <input
        type="text"
        name="ExtraInfo"
        className='large-input'
        minlength="15" 
        maxlength="200" 
        placeholder="Enter between 15 and 200 characters"
       />
       
  </div>
  <input type="submit" className="submit-button" value="Submit" />
  
  </form>
  </div>
  </div>
  );
};
export default ContactForm;